import React from "react";

function Logo() {
  return (
    <h1 className="text-xl font-semibold tracking-tight">
      <a
        href="/"
        className="text-black hover:opacity-70 transition"
      >
        Michael Asaad
      </a>
    </h1>
  );
}

export default Logo;
